import PropTypes from "prop-types";
import content from "app-content";
import CommonProductTile from "../../common/ProductTile";
import ProductTileProgressIndicatorWrapper from "../../common/ProductTileProgressIndicatorWrapper";
import CustomerItemsProductTileControls from "../../../containers/customerItems/ProductTileControls";
import EarlyAccesBadge from "../../common/EarlyAccessBadge";
import styles from "./index.css";
import classnames from "classnames";
import { useDelayedProgressIndicator } from "./useDelayedProgressIndicator";
import { useDisabledControlsWhilstRemoving } from "./useDisabledControlsWhilstRemoving";
import ProductPriceComponentsExtended from "../../common/ProductPriceComponentsExtended";
import { SAVED_ITEMS_CTAREF } from "../constants";

const ProductTile = ({
  isDeletingOrDeleted,
  isToBagInProgressOrComplete,
  ...rest
}) => {
  const isRemoving = isDeletingOrDeleted || isToBagInProgressOrComplete;
  const { isInProgress, setInProgress } = useDelayedProgressIndicator({
    isRemoving
  });
  const { isControlsEnabled, setControlsEnabled } =
    useDisabledControlsWhilstRemoving({
      isEnabled: !isRemoving
    });

  let ariaLabel = null;
  if (isDeletingOrDeleted) {
    ariaLabel = content.saved_items_accessibility_delete_loading;
  } else if (isToBagInProgressOrComplete) {
    ariaLabel = content.saved_items_accessibility_move_to_bag;
  }

  const onTransitionEnd = ({ propertyName }) => {
    if (propertyName === "opacity") {
      if (isRemoving) {
        setInProgress();
      } else {
        setControlsEnabled();
      }
    }
  };

  return (
    <ProductTileProgressIndicatorWrapper
      whenInProgressMessage={ariaLabel}
      isInProgress={isInProgress}
      visibleOverlayClassName={styles.visibleProgressOverlay}
    >
      <div
        className={classnames(styles.customerItemsProductTile, {
          [styles.hide]: isRemoving
        })}
        onTransitionEnd={onTransitionEnd}
      >
        <CommonProductTile
          ProductTileControls={CustomerItemsProductTileControls}
          ProductPriceComponents={ProductPriceComponentsExtended}
          ProductTileBadges={EarlyAccesBadge}
          ctaRef={SAVED_ITEMS_CTAREF}
          {...rest}
          isForceDisabled={!isControlsEnabled}
        />
      </div>
    </ProductTileProgressIndicatorWrapper>
  );
};

ProductTile.propTypes = {
  isDeletingOrDeleted: PropTypes.bool.isRequired,
  isToBagInProgressOrComplete: PropTypes.bool.isRequired
};

export default ProductTile;
